module.exports = __webpack_public_path__ + "img/image149.66fa1147.png";